const SUBTITLES = [
  'O que você quer fazer hoje?',
  'Por onde começamos?',
  'O que precisa da sua atenção primeiro?',
]

function greetingForHour(hour: number): string {
  if (hour >= 5 && hour < 12) return 'Bom dia'
  if (hour >= 12 && hour < 18) return 'Boa tarde'
  return 'Boa noite'
}

// Variante estável por dia (nada de sortear a cada render).
function subtitleForToday(): string {
  const dayIndex = Math.floor(Date.now() / 86_400_000)
  return SUBTITLES[dayIndex % SUBTITLES.length]
}

// `subtitle` opcional sobrepõe o pool por-dia: a página de Nova conversa passa
// uma frase própria ("Escolha um agente e escreva o que precisa").
export function Greeting({ userName, subtitle }: { userName: string | null; subtitle?: string }) {
  const firstName = (userName || '').trim().split(/\s+/)[0] || null
  const greeting = greetingForHour(new Date().getHours())

  return (
    <div className="relative space-y-1.5 text-center">
      <h1 className="text-[30px] font-semibold leading-tight tracking-[-0.022em] text-foreground">
        {firstName ? `${greeting}, ${firstName}.` : `${greeting}.`}
      </h1>
      <p className="text-[15px] text-muted-foreground">{subtitle ?? subtitleForToday()}</p>
    </div>
  )
}
